<template>
  <div style="position:relative;">
    <div class="rasgado rasgado-top"></div>

    <section class="itinerario-poster" ref="sectionRef">

      <h2 class="poster-title"><br /><br />Itinerario</h2>
  <span class="sub">
            Agradecemos tu puntualidad. <br />
            ¡No queremos empezar sin ti ni que te pierdas ningun momento especial! Llega a tiempo para compartir cada instante de esta noche.
          </span>
      <div
        v-for="(evento, index) in eventos"
        :key="evento.nombre"
        class="poster-item"
        :ref="el => itemRefs[index] = el"
      >
        <img :src="evento.icono" class="poster-icon" />
        <p class="poster-text">
          <span class="evento-nombre">{{ evento.nombre }}</span>
          <span class="evento-hora">{{ evento.hora }}</span>
          <span v-if="evento.nota" class="evento-nota">{{ evento.nota }}</span>
        </p>
      </div>
    </section>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import gsap from 'gsap'

export default {
  name: 'ItinerarioPoster',
  setup() {
    const eventos = [
         

         {
        nombre: ' Recepción',
        hora: '5:30 PM',
        icono: require('@/assets/copa.png')
      },
           {
        nombre: ' Cena',
        hora: '6:00 PM',
        icono: require('@/assets/cen.avif')
      },
           {
        nombre: ' Ceremonia',
        hora: '8:00 PM',
        icono: require('@/assets/valss.png')
      },
     
  
      {
        nombre: 'Fiesta ',
        hora: '9:00 PM - 2:00 AM',
        nota: 'A disfrutar la fiesta!',
        icono: require('@/assets/fiesta.avif')
      }
    ]

    const itemRefs = ref([])
    const sectionRef = ref(null)

    onMounted(() => {
      itemRefs.value.forEach((el, index) => {
        if (!el) return

        const icon = el.querySelector('.poster-icon')
        const text = el.querySelector('.poster-text')

        gsap.set([icon, text], { opacity: 0 })

        const animations = [
          { y: 40 },
          { x: -40 },
          { scale: 0.85 },
          { x: 40 },
          { y: -40 },
          { scale: 0.9 },
          { x: -30 },
          { y: 30 }
        ]

        const fromVars = animations[index % animations.length]

        const observer = new IntersectionObserver((entries, obs) => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return

            gsap.fromTo(
              icon,
              { ...fromVars, opacity: 0 },
              { opacity: 1, x: 0, y: 0, scale: 1, duration: 1, ease: 'power3.out' }
            )

            gsap.fromTo(
              text,
              { y: 20, opacity: 0 },
              { y: 0, opacity: 1, duration: 1, delay: 0.2, ease: 'power2.out' }
            )

            obs.unobserve(entry.target)
          })
        }, { threshold: 0.3 })

        observer.observe(el)
      })
    })

    return { eventos, itemRefs, sectionRef }
  }
}
</script>

<style scoped>
.itinerario-poster {
  text-align: center;
  position: relative; /* 🔥 necesario para que el rasgado se posicione aquí */
}

.poster-title {
  font-family: 'Playfair Display', serif;
  font-size: 44px;
  letter-spacing: 2px;
  color: #514e4e;
  margin-bottom: 50px;
}

.poster-item {
  margin-bottom: 42px;
}

.poster-icon {
  width: 114px;
  height: auto;
  margin-bottom: 12px;
}

.poster-text {
  font-family: 'Playfair Display', serif;
  color: #282727;
  line-height: 1.4;
}

.evento-nombre {
  display: block;
  font-size: 22px;
}

/* Rasgados */
.rasgado {
  position: absolute;
  left: 0;
  width: 100%;
  height: 40px;
  background: #fff; /* o el color de la sección anterior */
  z-index: 5;
  pointer-events: none;
}


.rasgado-top {
  top: 0;  background:#f0c9d3;

  clip-path: polygon(0% 70%, 18% 55%, 38% 78%, 58% 52%, 78% 75%, 100% 60%, 100% 0%, 0% 0%);
}

.rasgado-bottom {
  bottom: 0;
  clip-path: polygon(0% 30%, 18% 45%, 38% 22%, 58% 48%, 78% 25%, 100% 40%, 100% 100%, 0% 100%);
}

.evento-hora {
  display: block;
  font-size: 20px;
  font-style: italic;
  margin-top: 4px;
}

.sub {
  font-family: 'Playfair Display', serif;
  color: #3d3939;
  line-height: 1.4;
  position: relative;
  z-index: 2;
  display: block;
  margin-bottom: 30px;
margin-top:-20px;
  opacity: 1;
}
</style>
